import { render } from "./Packing3dBackward.vue?vue&type=template&id=2aaeeb66"
import script from "./Packing3dBackward.vue?vue&type=script&lang=js"
export * from "./Packing3dBackward.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__